// jQuery to collapse the navbar on scroll
function collapseNavbar() {
    if ($(".header-wrapper").offset().top > 50) {
        $(".navbar-fixed-top").addClass("top-nav-collapse");
    } else {
        $(".navbar-fixed-top").removeClass("top-nav-collapse");
    }
}

$(window).scroll(collapseNavbar);
$(document).ready(collapseNavbar);


$(document).ready(function() {
//Size chart
$('.size-chart-open-popup').magnificPopup({
  type:'inline',
  removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {
    beforeOpen: function() {
       this.st.mainClass = this.st.el.attr('data-effect');
    }
  },
  midClick: true
});

//Login Modul
$('.login-popup').magnificPopup({
  type:'inline',
  removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {
    beforeOpen: function() {
       this.st.mainClass = this.st.el.attr('data-effect');
    }
  },
  midClick: true
});
  
  
//Calculate header hight and offset div on first page
var height= $(".header-wrapper").height();

$(".index-sections").css({marginTop: height - 60});


//accordion
  
 /* OLD 2022-07-27
 var allPanels = $('.accordion-info').hide();
    
  $('.accordion-header').click(function() {
      $(this).next().slideToggle();
      allPanels.not($(this).next()).slideUp();
  });
  */

   var allPanels = $('.accordion-info').hide();
    
  $('.accordion-header').click(function() {
      $(this).next().slideToggle();
      allPanels.not($(this).next()).slideUp();

        // If the clicked element has the active class, remove the active class from EVERY .accordion-header>.state element
        if ($(this).hasClass("active")) {
          $(".accordion-header").removeClass("active");
        }
        // Else, the element doesn't have the active class, so we remove it from every element before applying it to the element that was clicked
        else {
          $(".accordion-header").removeClass("active");
          $(this).addClass("active");
        }

  });


  
});


